// A shared hover region includes the thumbnail, panel and the narrow gap between them.
let active=null, closeTimer, openTimer, point={x:-1,y:-1};
const fine=()=>matchMedia('(hover:hover) and (pointer:fine)').matches;
const dense=item=>item?.closest('.product-grid')?.getAttribute('product-grid-view')==='zoom-out';
const inside=(r,p)=>p.x>=r.left&&p.x<=r.right&&p.y>=r.top&&p.y<=r.bottom;
const galleryCache=new Map(), galleryRequests=new WeakMap();
function imageReady(url){
 if(galleryCache.has(url))return galleryCache.get(url);
 const promise=new Promise((resolve,reject)=>{
  const image=new Image();
  const timeout=setTimeout(()=>finish(false),15000);
  function finish(ok){clearTimeout(timeout);image.onload=null;image.onerror=null;ok?resolve(image):reject(new Error('Image unavailable'));}
  image.onload=()=>finish(true);image.onerror=()=>finish(false);image.src=url;
 });
 galleryCache.set(url,promise);promise.catch(()=>galleryCache.delete(url));return promise;
}
function gallerySources(panel){return [...panel.querySelectorAll('.jw-image-sources [data-src]')];}
function warmGallery(panel){
 const sources=gallerySources(panel),index=Number(panel.dataset.imageIndex)||0;
 if(sources.length>1)imageReady(sources[(index+1)%sources.length].dataset.src).catch(()=>{});
}
function galleryStatus(panel,message){
 let status=panel.querySelector('.jw-gallery-status');
 if(!status){status=document.createElement('span');status.className='jw-gallery-status';status.setAttribute('role','status');panel.querySelector('.jw-quick-media').append(status);}
 status.textContent=message;status.hidden=!message;
}
async function changeImage(panel,direction){
 const sources=gallerySources(panel);if(sources.length<2)return;
 const previous=Number(panel.dataset.imageIndex)||0;
 const pending=Number(panel.dataset.pendingImageIndex ?? previous);
 const index=(pending+direction+sources.length)%sources.length,token={};
 galleryRequests.set(panel,token);panel.dataset.pendingImageIndex=index;
 panel.querySelector('.jw-quick-media').setAttribute('aria-busy','true');galleryStatus(panel,'Loading image…');
 try{
  await imageReady(sources[index].dataset.src);
  if(galleryRequests.get(panel)!==token||!panel.isConnected)return;
  const img=panel.querySelector('.jw-order-thumb img');
  img.removeAttribute('srcset');img.removeAttribute('sizes');img.loading='eager';
  img.src=sources[index].dataset.src;img.alt=sources[index].dataset.alt||'';
  panel.dataset.imageIndex=index;
  panel.querySelector('.jw-image-count').textContent=`${index+1} / ${sources.length}`;
  galleryStatus(panel,'');warmGallery(panel);
 }catch{
  if(galleryRequests.get(panel)===token)galleryStatus(panel,'Image could not load. Click an arrow to retry.');
 }finally{
  if(galleryRequests.get(panel)===token){delete panel.dataset.pendingImageIndex;panel.querySelector('.jw-quick-media').removeAttribute('aria-busy');}
 }
}
// Capture phase prevents theme/card bubbling handlers from swallowing gallery clicks.
// Delegation survives collection filters, pagination and theme-editor section replacement.
document.addEventListener('click',event=>{
 const arrow=event.target.closest?.('.jw-quick-card .jw-image-prev,.jw-quick-card .jw-image-next');
 if(!arrow)return;
 event.preventDefault();event.stopImmediatePropagation();
 clearTimeout(closeTimer);closeTimer=null;
 changeImage(arrow.closest('.jw-quick-card'),arrow.classList.contains('jw-image-next')?1:-1);
},true);
function inRegion(){
 if(!active)return false;
 const a=active.trigger.getBoundingClientRect(),b=active.panel.getBoundingClientRect();
 if(inside(a,point)||inside(b,point))return true;
 const gap=b.left>=a.right?{left:a.right,right:b.left,top:Math.min(a.top,b.top),bottom:Math.max(a.bottom,b.bottom)}:
 b.right<=a.left?{left:b.right,right:a.left,top:Math.min(a.top,b.top),bottom:Math.max(a.bottom,b.bottom)}:null;
 return gap&&inside(gap,point);
}
function close(restore=false){
 clearTimeout(closeTimer);clearTimeout(openTimer);
 closeTimer=null;openTimer=null;
 if(!active)return;
 const {panel,trigger}=active;active=null;
 if(panel.matches(':popover-open'))panel.hidePopover();
 panel.removeAttribute('data-open');panel.removeAttribute('popover');
 trigger.setAttribute('aria-expanded','false');
 if(restore)trigger.focus();
}
function position(){
 if(!active)return;
 const {panel,trigger}=active,r=trigger.getBoundingClientRect(),w=panel.offsetWidth,h=panel.offsetHeight;
 const x=r.right+6+w<=innerWidth-12?r.right+6:r.left-w-6;
 panel.style.left=`${Math.max(12,Math.min(x,innerWidth-w-12))}px`;
 panel.style.top=`${Math.max(12,Math.min(r.top-20,innerHeight-h-12))}px`;
}
function open(trigger,focus=false){
 const item=trigger.closest('.product-grid__item');if(!dense(item))return;
 clearTimeout(closeTimer);
 if(active?.trigger===trigger){if(focus)active.panel.querySelector('.jw-quick-close')?.focus();return;}
 close();
 const panel=item.querySelector(':scope > .jw-quick-card');if(!panel)return;
 active={panel,trigger,item};panel.setAttribute('data-open','');
 trigger.setAttribute('aria-expanded','true');trigger.setAttribute('aria-controls',panel.id);
 if(typeof panel.showPopover==='function'){panel.setAttribute('popover','manual');panel.showPopover();}
 warmGallery(panel);position();if(focus)panel.querySelector('.jw-quick-close')?.focus();
}
function scheduleClose(){
 if(closeTimer)return;
 closeTimer=setTimeout(()=>{closeTimer=null;if(!active||inRegion()||active.panel.contains(document.activeElement))return;close();},450);
}
document.addEventListener('pointermove',e=>{
 if(!fine())return;point={x:e.clientX,y:e.clientY};
 if(active){if(inRegion()) {clearTimeout(closeTimer);closeTimer=null;}else scheduleClose();}
});
document.addEventListener('pointerover',e=>{
 if(!fine()||!(e.target instanceof Element))return;
 point={x:e.clientX,y:e.clientY};
 if(active&&(active.panel.contains(e.target)||inRegion()))return;
 const trigger=e.target.closest('.jw-catalog .jw-quick-trigger');if(!trigger)return;
 clearTimeout(openTimer);openTimer=setTimeout(()=>{if(trigger.isConnected&&trigger.matches(':hover'))open(trigger);},140);
});
document.addEventListener('pointerout',e=>{
 if(!active||!(e.target instanceof Node))return;
 if(active.panel.contains(e.target)||active.trigger.contains(e.target)){
  if(e.relatedTarget instanceof Node&&(active.panel.contains(e.relatedTarget)||active.trigger.contains(e.relatedTarget)))return;
  scheduleClose();
 }
});
document.addEventListener('click',e=>{
 if(!(e.target instanceof Element))return;
 const trigger=e.target.closest('.jw-quick-trigger');
 if(trigger){e.preventDefault();open(trigger,true);return;}
 if(e.target.closest('.jw-quick-close')){close(true);return;}
 if(active&&!active.panel.contains(e.target)&&!active.trigger.contains(e.target))close();
});
document.addEventListener('focusout',()=>{if(active)scheduleClose();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&active){e.preventDefault();close(true);}});
window.addEventListener('resize',position);
window.addEventListener('scroll',e=>{if(active&&!(e.target instanceof Node&&active.panel.contains(e.target)))position();},true);
new MutationObserver(()=>{if(active&&(!active.item.isConnected||!dense(active.item)))close();}).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['product-grid-view']});
